export const LONG_POLLING_TIMEOUT = 5 * 60 * 1000;
